module.exports = __webpack_public_path__ + "media/npc_dota_hero_ogre_magi.e331c9ed.webm";